import { makeStyles, createStyles } from '@material-ui/core/styles';

const brandStyles = {
  forreston: {
    logo: {
      height: 25
    }
  },
  oakwood: {
    logo: {
      height: 32
    }
  }
};

export default makeStyles((theme) =>
  createStyles({
    header: {
      height: theme.sizes.headerHeight,
      backgroundColor: theme.colors.header__background_primary,
      justifyContent: 'center',
      display: 'block'
    },
    logoLockup: {
      display: 'flex',
      alignItems: 'center'
    },
    logo: ({ brandName }) => ({
      height: 48,
      marginLeft: 15,
      display: 'block',
      ...(brandStyles[brandName]?.logo || {})
    }),
    partnerLogoContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      borderLeft: `1px solid ${theme.colorPalette.beige_75}`
    },
    partnerLogo: {
      height: 36,
      maxWidth: 180,
      objectFit: 'contain'
    },
    toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
      height: theme.sizes.headerHeight
    },
    searchContainer: {
      width: '100%'
    }
  })
);
